var map = {
	"./categories/all.svg": "92d5",
	"./categories/devices.svg": "987b",
	"./categories/events.svg": "936e",
	"./categories/internet.svg": "5eb1",
	"./connection-0.svg": "fca3",
	"./connection-1.svg": "1d1f",
	"./connection-2.svg": "cbfb",
	"./connection-4.svg": "f74b",
	"./folder.svg": "fa17",
	"./screenshots/additional-angle.svg": "076f",
	"./screenshots/modal/arrow-down.svg": "e29a",
	"./screenshots/modal/close.svg": "da8c",
	"./screenshots/modal/download.svg": "e97c",
	"./screenshots/modal/first.svg": "8c1d",
	"./screenshots/modal/last.svg": "a2c3",
	"./screenshots/modal/next.svg": "2563",
	"./screenshots/modal/pause.svg": "c3ee",
	"./screenshots/modal/play.svg": "3f15",
	"./screenshots/modal/prev.svg": "a9ca",
	"./wrench.svg": "7306"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e85a";